export const HermesysColors = {
  Blue: `rgba(0, 0, 253, 1)`,
  VoicePlainColor: `rgba(70,112,112,1)`,
  ButtonBackgroundGray: `rgba(179,179,179,1)`,
  ButtonBorderColor: `rgba(109, 109, 109, 1)`,
  White: `rgba(255,255,255,1)`,
  Gray: `gray`,
  main: {
    White: `rgba(255,255,255,1)`,
    background: `rgba(32,41,68,1)`,
    highlightText: `rgba(81,90,113,1)`,
    dimWhite: `rgba(255,255,255,0.3)`,
    greenText: `rgba(71,166,33,0.8)`,
    dimYellow: `rgba(255,255,0,0.6)`,
    redColor: `rgba(230,47,20,0.8)`,
    saveIconColor: `rgba(85,127,184,0.8)`,
  },
};
